import React, {useEffect, useState} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsListAction, fetchCardsThemeListAction, ROUTE_PATH, selectStore} from "../../../utils";
import {MyText} from "../../../components";
import {LeftOutlined} from "@ant-design/icons";
import { PageName, ButtonContainer, ThemeCollapse, StyledImage, StyledImageWrapper } from "../style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../../utils/context/embed";
import { ThemesModal } from "../../Articles/ThemesPopup/ThemesPopup";
import { ThemeButton, ThemeMobileButton } from "../style";
import { Helmet } from "react-helmet";

export const CardCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const age = searchParams.get("age");
  // const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
  const topicIdFromParams = searchParams.get('topic_id');
  const segmentedParams: any = searchParams.get('type');
  const [authors, setAuthors] = useState([]);
  const [articles, setArticles] = useState([]);
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
  const cardsThemeList = useSelector((state: any) => state.materials?.cardsThemeList ?? { data: null, loading: false });

  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
  const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
  const [themes, setThemes] = useState([]);
  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const isTablet = screens.md && !screens.xl && !screens.xxl;


  const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };  

  // const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);

  // useEffect(() => {
  //     const fetchContent = async () => {
  //         try {
  //             const response = await fetchCardsThemeList();
  //             setThemes(response.categories || []);
  //         } catch (error) {
  //             console.error('Error fetching themes:', error);
  //         }
  //     };
  
  //     fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchCardsThemeListAction());
  }, []);

  useEffect(() => {
    if (!cardsThemeList.success || !cardsThemeList.data) return;
    setThemes(cardsThemeList.data.categories || []);
  }, [cardsThemeList.success, cardsThemeList.data]);

  const mock = {
    "success": true,
    "cards": [
      {
        "id": 4,
        "title": "Времена года",
        "text": "",
        "lang": "ru",
        "audio_link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/bf907c9eb7f0ba2727388c56ac105bb71479c241.mp3",
        "preview_image": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/9e6c9bb350e4317296a31e276362bbefd3f96f8b.jpg",
        "pictures": [
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/9e6c9bb350e4317296a31e276362bbefd3f96f8b.jpg",
            "name": "времена года-Photoroom.jpg",
            "start": 0,
            "end": 10
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/1c393ca1a16888a4325a2f767db484f9265f49bb.jpg",
            "name": "зима-Photoroom.jpg",
            "start": 10,
            "end": 18
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/7ced6feeda1a8ac16b635bc1feee77aa4f11a8d9.jpg",
            "name": "зима-Photoroom (1).jpg",
            "start": 18,
            "end": 25.8
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/7ad8dbecef7ad43f4c66f6b8c1db9df04bddf6d8.jpg",
            "name": "весна-Photoroom.jpg",
            "start": 25.8,
            "end": 29.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/f1262fed046099eae0104d16a70dd9bb10ff3606.jpg",
            "name": "весна-Photoroom (1).jpg",
            "start": 29.2,
            "end": 38
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/dbaba047598eb871116c5afc999c5f169dd8bc00.jpg",
            "name": "лето-Photoroom.jpg",
            "start": 38,
            "end": 45.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/11db421f0a0cb36bb5c704680c355905ab5cf194.jpg",
            "name": "лето-Photoroom (1).jpg",
            "start": 45.2,
            "end": 55.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/8e5da8be98cb62870417e3797b80c8522c6a7438.jpg",
            "name": "осень-Photoroom.jpg",
            "start": 55.2,
            "end": 58.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/36e55d0b5f5b277d409af95975a91fdb443e073f.jpg",
            "name": "осень-Photoroom (1).jpg",
            "start": 58.2,
            "end": 71.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/9e6c9bb350e4317296a31e276362bbefd3f96f8b.jpg",
            "name": "времена года-Photoroom.jpg",
            "start": 71.2,
            "end": 82.2
          }
        ],
        "images_count": 10,
        "category_id": 1,
        "category_name": "Мой мир",
        "min_age": 0,
        "max_age": 6,
        "age_range": "0 лет - 6 лет",
        "created_at": "2025-06-18 17:35:56",
        "updated_at": "2025-06-18 17:46:17"
      },
      {
        "id": 3,
        "title": "Город",
        "text": "",
        "lang": "ru",
        "audio_link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/9c97e353617bc211116e94fe921d43360d7f3044.mp3",
        "preview_image": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/4aa43b6af0491042150c3457f1a20ed26bdb471d.jpg",
        "pictures": [
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/4aa43b6af0491042150c3457f1a20ed26bdb471d.jpg",
            "name": "20250618_1534_Friendly Urban Exploration_simple_compose_01jy19jrbaeh6agdj8rweq44sh.png",
            "start": 0,
            "end": 8
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/9c4921f0e291d4c7aab352682950a043f19bcfea.jpg",
            "name": "20250618_1538_Городская детская иллюстрация_remix_01jy19s25sewsvx5dwjvk0fync.png",
            "start": 8,
            "end": 15
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/ad57be760d5c9739f42dfbbae4ba740d6ca62240.jpg",
            "name": "20250618_1541_Городская улица днём_remix_01jy19yr2ge139apcec1q161gd.png",
            "start": 15,
            "end": 20
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/87a2ff970e3e9e1766ed49561a3e63d18880f45c.png",
            "name": "cropped_image.png",
            "start": 20,
            "end": 24
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/fc22b000e25c7d94817c42b2ac0febed5cd3ec62.png",
            "name": "cropped_image.png",
            "start": 24,
            "end": 31
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/767ffd359dedffede86e45fc47f692598b7828d5.jpg",
            "name": "20250618_1610_Городские детские достопримечательности_remix_01jy1bkpe7e8cbxdc940xvej1d (1)1.png",
            "start": 31,
            "end": 39
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/f7e4c2c483cc282189a40ef6937cd5725ab33e43.png",
            "name": "cropped_image.png",
            "start": 39,
            "end": 44
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/d6f1091e5468cdf39e33d637e863bc6ba823f9bb.png",
            "name": "cropped_image.png",
            "start": 44,
            "end": 60.2
          }
        ],
        "images_count": 8,
        "category_id": 1,
        "category_name": "Мой мир",
        "min_age": 0,
        "max_age": 6,
        "age_range": "0 лет - 6 лет",
        "created_at": "2025-06-18 16:43:18",
        "updated_at": "2025-06-18 16:43:18"
      },
      {
        "id": 2,
        "title": "Дом",
        "text": "",
        "lang": "ru",
        "audio_link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/06964c84b2d669c767b2742e8935c2cc638b2e41.mp3",
        "preview_image": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/4b268d400219545ff7b73bb98fe9e6797490a02c.png",
        "pictures": [
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/4b268d400219545ff7b73bb98fe9e6797490a02c.png",
            "name": "20250618_1135_Домашний уют ребёнка_simple_compose_01jy0vwxh9ftmbsqnt3848e2kr.png",
            "start": 0,
            "end": 11
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/f3d304528d906ce0bbd8b2f0c6cfd3dfd1447d67.png",
            "name": "20250618_1142_Жилища и персонажи_remix_01jy0w8fk7e89r782fydzb565h.png",
            "start": 11,
            "end": 25
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/1ca4f2e3c497d8b5113bda74041b92674b28a95c.png",
            "name": "20250618_1147_Контрасты детства_remix_01jy0wkg8qe1nrz061wnd17esb.png",
            "start": 25,
            "end": 35
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/b122e7ae6a24dc83f425dc63d6b105dd29677374.jpg",
            "name": "20250618_1152_Уютный Домашний Интерьер_remix_01jy0wvx9sf94rg6eawa204ec1.png",
            "start": 35,
            "end": 42
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eyygmkqs/d7e5278debdb813927e2a3e18703dd261d9eab17.jpg",
            "name": "20250618_1157_Уют в доме_remix_01jy0x5eyfemr8tj8mdedhx6kb.png",
            "start": 42,
            "end": 52.8
          }
        ],
        "images_count": 5,
        "category_id": 1,
        "category_name": "Мой мир",
        "min_age": 0,
        "max_age": 6,
        "age_range": "0 лет - 6 лет",
        "created_at": "2025-06-18 12:06:40",
        "updated_at": "2025-06-18 15:09:25"
      },
      {
        "id": 1,
        "title": "Почему от лука плачут?",
        "text": "Лук используется в пищу с очень давних времен и все, наверное, знают, что когда начинают резать лук, из глаз начинают течь слезы. Оказывается, в луке содержится масло, в состав которого входит сера, что не только придает луку резкий запах, но и раздражает глаза.",
        "lang": "ru",
        "audio_link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eqyiiyuw/cc2eb2fe7c750376b0b27e9fbf03817fa777de2e.mp3",
        "preview_image": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eqyiiyuw/94c4d0063ccaa3c4478276607cb94bcb4cdb6df4.png",
        "pictures": [
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eqyiiyuw/94c4d0063ccaa3c4478276607cb94bcb4cdb6df4.png",
            "name": "luk.png",
            "start": 0,
            "end": 9.2
          },
          {
            "link": "https://ff.bilimal.kz/ycosuyki/oykcaokq/eqyiiyuw/dc540baef75bbfc145c702da7b3e35888c0bfb45.png",
            "name": "79f712ad-7452-4527-a82b-aec2f880c15b.png",
            "start": 9.2,
            "end": 17.4
          }
        ],
        "images_count": 2,
        "category_id": 1,
        "category_name": "Мой мир",
        "min_age": 0,
        "max_age": 6,
        "age_range": "0 лет - 6 лет",
        "created_at": "2025-06-13 16:30:50",
        "updated_at": "2025-06-16 17:11:33"
      }
    ],
    "pagination": {
      "current_page": 1,
      "per_page": 20,
      "total_count": 4,
      "page_count": 1
    }
  }



  const {materials: {cardsList: cardsListState}} = useSelector(selectStore)

  useEffect(() => {
    
      dispatch(fetchCardsListAction({
        // category: gameCategory,
        // fromAge,
        // toAge
      }))
    
  }, [])

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');

  if (!topicIdFromParams) {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
    return;
  }

  const topicId = Number(topicIdFromParams);
  const matchedTheme = themes.find(theme => theme.id === topicId);

  if (matchedTheme) {
    setSelectedSubThemeId(topicId);
    setSelectedSubThemeName(matchedTheme.name);
    setSelectedParentTheme(matchedTheme);
  } else {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
  }
}, [themes, searchParams, t]);

  const handleSelectCard = (id: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.CURRENT_CARD, { currentCard: id}),

    }

    embeddedNavigate(path)
  }

  const showThemesModal = () => {
    setIsThemesModalVisible(true);
  };

   const handleThemesModalOk = () => {
      setIsThemesModalVisible(false);
  };

  const handleThemesModalCancel = () => {
      setIsThemesModalVisible(false);
  };

  const handleThemesDataSubmit = (items: any[], totalCount: number) => {
  const type = searchParams.get('type');

  if (type === 'authors') {
    setAuthors(items);
    setTotalCount(totalCount);
  } else {
    setArticles(items);
    setTotalCount(totalCount);
  }
};

  const handleGoBack = () => {
    embeddedNavigate('/');
  }

  const parentThemesButton = themes;

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


      <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <ThemesModal
                        visible={isThemesModalVisible}
                        onOk={handleThemesModalOk}
                        onCancel={handleThemesModalCancel}
                        themes={themes}
                        onDataSubmit={handleThemesDataSubmit}
                        selectedSubThemeId={selectedSubThemeId}
                        setSelectedSubThemeId={setSelectedSubThemeId}
                        isCards={true}
                    />
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 26}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("trainingCards")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {t("trainingCards")}
                </MyText>
              </>
            )}
        </Row>
        <Row gutter={32}>
        <Col span={screens.xs || isTablet ? 24 : 18}>
        
        <Card style={{borderRadius: '20px'}}>
          {(isMobile || isTablet) && (
            <ThemeMobileButton isMobile={isMobile} onClick={showThemesModal} style={{marginBottom: 15}}>
              {t("topics")}
            </ThemeMobileButton>
                              )}
          <Spin spinning={cardsListState?.loading}>
            <Row gutter={[24, 24]}>
            {cardsListState?.data?.cards?.length ? (
                cardsListState.data.cards.map((oneGame: any) => (
                  <Col
                    key={oneGame.id + "-game-category"}
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    <Card
                      bordered
                      hoverable
                      onClick={() => handleSelectCard(oneGame.id)}
                      style={{
                        borderRadius: '24px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Row justify="center" style={{height: screens.xs ? 'auto' : '500px'}}>
                        <StyledImageWrapper>
                  <Image
                    preview={false}
                    style={{height: '100%', width: '100%'}}
                    src={oneGame.preview_image}
                  />
                </StyledImageWrapper>
                      </Row>
                      <Col style={{ marginTop: 26, padding: 0, height: '50px' }}>
                        <MyText weight={700} size={18}>
                          {oneGame.title}
                        </MyText>
                      </Col>
                    </Card>
                  </Col>
                ))
              ) : (
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={24}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block' }}
                >
                  {t("noFound")}
                </MyText>
              )}
            </Row>
          </Spin>
        </Card>
        </Col>
          {!(isMobile || isTablet) && (
                  <Col span={6}>
                    <Card style={{ width: '100%', borderRadius: '20px' }}>
                      {!isMobile && (
                        <PageName style={{ width: '100%' }}>
                        <MyText color="#0A033C" size={18} weight={800} style={{ marginBottom: '16px', fontFamily: 'Nunito' }}>
                          {t("topics")}
                        </MyText>
                        <ThemeButton
                                                key="all"
                                                onClick={async () => {
                                                setSelectedSubThemeId(null);
                                                setSelectedSubThemeName(t("all"));
                                                setActiveKeyTheme(null);
                                                setSelectedParentTheme({ id: null, name: t("all") });
                                                setSearchParams(prevParams => {
                                                    prevParams.set('topic_id', '');
                                                    return prevParams;
                                                });
                                                try {
                                                    // const response = await fetchCardsListAction(null);
                                                    // setThemes(response.themes);
                                                    dispatch(fetchCardsListAction(null))
                                                } catch (error) {
                                                    console.error('Error fetching all content:', error);
                                                }
                                                }}
                                                style={{
                                                height: 'auto',
                                                padding: '12px 16px',
                                                justifyContent: 'flex-start',
                                                marginBottom: '8px',
                                                background: selectedParentTheme?.id === null ? 'rgb(231, 250, 255)' : 'none',
                                                }}
                                            >
                                                <Col span={24} style={{ display: 'flex',  paddingLeft: 0,  paddingRight: 0,  justifyContent: 'flex-start' }}>
                                                <MyText
                                                    color={selectedParentTheme?.id === null ? 'rgb(0, 141, 210)' : '#0A033C'}
                                                    size={18}
                                                    weight={600}
                                                    style={{
                                                    lineHeight: '24px',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                    }}
                                                >
                                                    {t("all")}
                                                </MyText>
                                                </Col>
                                            </ThemeButton>   
                        {parentThemesButton.map(parentTheme => (
                                            <ThemeButton key={parentTheme.id} onClick={async () => {
                                                setSelectedSubThemeId(parentTheme.id);
                                                setSelectedSubThemeName(parentTheme.name);
                                                setActiveKeyTheme(null);
                                                setSelectedParentTheme(parentTheme);
                                                setSearchParams(prevParams => {
                                                    prevParams.set('topic_id', parentTheme.id);
                                                    return prevParams;
                                                });
                                                try {
                                                    // const response = await fetchContentByCategory(id, parentTheme.id);
                                                    // setThemes(response.themes);
                                                    // setLessons(response.content);
                                                     dispatch(fetchCardsListAction({category_id: parentTheme.id}))
                                                } catch (error) {
                                                    console.error('Error fetching content by topic:', error);
                                                }
                                            }} style={{height: "auto",padding: '12px 16px', justifyContent: 'flex-start',marginBottom: '8px', background: selectedParentTheme?.id === parentTheme.id ? 'rgb(231, 250, 255)' : "none" }}>
                                                <Col span={24} style={{ display: 'flex', paddingLeft: 0,  paddingRight: 0, justifyContent: 'flex-start' }}>
                                                    <MyText
                                                    color={selectedParentTheme?.id === parentTheme.id ? 'rgb(0, 141, 210)' : '#0A033C'}
                                                    size={18}
                                                    weight={600}
                                                    style={{
                                                        lineHeight: '24px',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word',
                                                    }}
                                                    >
                                                    {parentTheme.name}
                                                    </MyText>
                                                </Col>
                                            </ThemeButton>
                                            ))}
                      </PageName>
                      )}
                    </Card>
                  </Col>
                  )}
                          </Row>

      </Col>

      
    </Row>
        </Row>
  </>

  )
}